import script from "./DocumentSigned.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentSigned.vue?vue&type=script&setup=true&lang=js"

import "./DocumentSigned.vue?vue&type=style&index=0&id=14af4ebf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14af4ebf"]])

export default __exports__